import styled, { css } from 'styled-components';
import {
  IconButtonColor,
  IconButtonShape,
  IconButtonSize,
  IconButtonState,
  IconButtonVariant,
} from '.';
import { colorSemanticsArray } from '@/styles/theme';

export type IconButtonStyleProps = {
  $size: IconButtonSize;
  $state: IconButtonState;
  $variant: IconButtonVariant;
  $color: IconButtonColor;
  $highContrast: boolean;
  $disabled: boolean;
  $mostrarEstilizacaoHover: boolean;
  $shape: IconButtonShape;
};

const colorBackground = {
  soft: 5,
  surface: 3,
  outline: 3,
  ghost: 4,
};

export const Container = styled.button<IconButtonStyleProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  cursor: ${({ $disabled }) => ($disabled ? 'default' : 'pointer')};

  position: relative;

  background-color: ${({ theme, $color, $variant, $disabled }) => {
    if ($disabled) return theme.colors.neutral.neutral_alpha[1];
    if (['ghost', 'outline'].includes($variant)) return 'transparent';
    if (colorSemanticsArray.includes($color))
      return theme.colors.semantic[
        `${$color}${$variant === 'solid' ? '' : '_alpha'}`
      ][9];
    if ($variant === 'solid') return theme.colors[$color][$color][9];
    return theme.colors[$color][`${$color}_alpha`][colorBackground[$variant]];
  }};

  border: ${({ theme, $color, $variant, $disabled }) => {
    if ($disabled)
      return `1px solid ${theme.colors[$color][`${$color}_alpha`][6]}`;
    if (['outline', 'surface'].includes($variant))
      return `1px solid ${theme.colors[$color][`${$color}_alpha`][8]}`;
    return 'none';
  }};

  ${({ theme, $size, $shape }) => {
    return css`
      border-radius: ${$shape === 'round'
        ? theme.radius['round']
        : theme.radius[$size >= 3 ? 3 : 2]}px;
      padding: ${$size >= 3 ? theme.spacing[2] : theme.spacing[1]}px;
    `;
  }}

  ${({ theme, $color, $variant, $disabled }) => {
    if ($disabled) return;

    return css`
      &:hover,
      &:active {
        cursor: pointer;
        background-color: ${theme.colors[$color][`${$color}_alpha`][
          $variant === 'outline' ? 2 : 3
        ]};
      }
    `;
  }};
`;

export const ContainerTotal = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ContainerBadge = styled.div`
  display: flex;

  position: absolute;
  z-index: 100;

  top: 0;
  right: 0;
`;
